var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("span", { staticClass: "text-muted" }, [
          _vm._v("\n                Brightfish admissions per cinema — last "),
          _c("strong", [_vm._v(_vm._s(_vm.bucket.weeks || 52))]),
          _vm._v(" cinema weeks\n                "),
          _vm.bucket.first_week
            ? _c("span", [
                _vm._v(
                  "(" +
                    _vm._s(_vm.bucket.first_week) +
                    " → " +
                    _vm._s(_vm.bucket.last_week) +
                    ")"
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No admissions data found.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.theatre_code }, [
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/admissions/cinema/" + row.theatre_code,
                            },
                          },
                          [_vm._v(_vm._s(row.theatre_code))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.theatre_name || "—"))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.city || "—"))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(row.weeks) +
                          "\n                            "
                      ),
                      row.weeks < _vm.bucket.weeks
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: { title: _vm.missingTitle(row) },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(
                          row.avg_week !== null
                            ? _vm.formatInt(row.avg_week)
                            : "—"
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            row.real_weighted != null
                              ? row.real_weighted + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      row.real_weighted != null && row.real_weighted <= 90
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title: "Minimum real: " + row.real_min + "%",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: {
                              to: "/admissions/cinema/" + row.theatre_code,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Per Year\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "4" } }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(2),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Code")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cinema")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("City")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("# Weeks")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-120" }, [
          _vm._v("Avg / week"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("Total")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
      _vm._v("\n                All figures come from "),
      _c("code", [_vm._v("admissions_week")]),
      _vm._v(
        ", saleshouse BF, compiled and estimated weeks alike.\n                "
      ),
      _c("strong", [_vm._v("Real %")]),
      _vm._v(" is the admissions-weighted average of the "),
      _c("code", [_vm._v("real")]),
      _vm._v(
        " field:\n                97.5 means every week was compiled from Cinedata, lower values mean part of the total was estimated.\n                ⚠ on the week count marks cinemas without a row for every week of the period.\n            "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }